import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

window.addEventListener(
  "load",
  function () {
    if (document.body.classList.contains("single-location")) {
      const locationTestimonialsSlider = new Swiper(
        document.querySelector(".location-testimonials .swiper"),
        {
          modules: [Navigation, Pagination],
          slidesPerView: 1,
          speed: 500,
          spaceBetween: 16,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          },
          breakpoints: {
            834: {
              slidesPerView: 2,
              spaceBetween: 24,
              centeredSlides: false,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 24,
              centeredSlides: false,
            },
          },
        },
      );
    }
  },
  false,
);
